<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Creación De Producto
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="onNuevo">Nuevo</v-btn>
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-xl>
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <modalComponent :abrirModal="objModal.abrirModal" :objeto="_.merge({},objetoPrincipal,objModal)"
                            :listGeneral="listGeneral" :parametros="parametros" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Aseguradora *" color="textbox" v-model="objetoPrincipal.idAseguradora"
                            :items="listGeneral.listAseguradoras" @change="onListarSeguro" item-value="idAseguradora"
                            item-text="aseguradora" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Seguro *" color="textbox" v-model="objetoPrincipal.idSeguro"
                            :items="listGeneral.listaSeguros" @change="onListarPoliza" item-text="seguro"
                            item-value="idSeguro" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Póliza *" color="textbox" v-model="objetoPrincipal.idPoliza"
                            :items="listGeneral.listaPolizas" @change="onListarProductos" item-value="idPoliza"
                            item-text="poliza" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" />
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objetoPrincipal.busqueda" clearable dense
                            prepend-inner-icon="search" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table :search="objetoPrincipal.busqueda" :headers="listGeneral.cabeceraProductos" :items="listGeneral.listaProductos"
                            class="elevation-3">
                            <template v-slot:item.accion="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="onEditar(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>
                            
                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-html="objetoPrincipal.busqueda"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        components: {
            modalComponent: () => import('@/components/constructor/producto/ModalProductoComponent.vue')
        },
        data() {
            return {
                elemento: 1,
                listGeneral: {},
                parametros: {},
                objModal: {
                    abrirModal: false,
                    titulo: 'Nuevo Producto'
                },
                objetoPrincipal: {}
            }
        },
        created() {
            try {
                var error = 'E';

                axios.post(`${BASE_URI}administrador/producto/cargaGeneral`,{})
                     .then((r) => {
                        if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if(_.size(_.get(r,['data','data'],[])) == 0){ error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                            this.listGeneral        = r.data.data.listas;
                            this.listGeneralInicio  = r.data.data.listas;
                            this.parametros         = r.data.data.parametros;
                            this.cargaGeneral();
                     })
                     .catch((e) =>{
                         mensajesAlerta(e, error);
                     });

            } catch (error) {
                mensajesAlerta(mensajeEstandar.errorPeticion, 'E');
            }
        },
        methods: {
            onListar(ruta, objeto) {
                return axios.post(`${BASE_URI}${ruta}`, objeto);
            },
            cargaGeneral() {
                this.onListarAseguradora()
                    .then((respuesta) => {
                        return this.onListarEstados('L');
                    })
                    .then((respuesta) => {
                        this.$set(this.objetoPrincipal, 'idAseguradora', this.listGeneral.listAseguradoras[0].idAseguradora);
                        return this.onListarSeguro('L');
                    })
                    .catch((e) => {
                        mensajesAlerta(e, 'E');
                    })
            },
            validar() {
                // if(this.$refs.form_datos_generales.validate())
                this.next();
            },
            onListarAseguradora() {
                return this.onListar('administrador/aseguradora/listar', { 'opcion': 'LC' })
                    .then((respuesta) => {
                        if(_.get(respuesta,['data','existeError'],true)) mensajeEstandar.errorPeticion;
                        if (_.size(_.get(respuesta,['data','data'],[])) == 0) throw respuesta.data.mensaje;
                            
                            this.$set(this.listGeneral, 'listAseguradoras', respuesta.data.data);
                        return respuesta;
                    });
            },
            onListarSeguro(event) {
                if (!_.isUndefined(event)) {
                    var objeto = {
                        'opcion': 'L_SEGURO',
                        'idAseguradora': _.get(this.objetoPrincipal, 'idAseguradora', null),
                        'idEstado': this.parametros.idEstadoDefault
                    };

                    this.$set(this.objetoPrincipal, 'idSeguro', null);
                    this.$set(this.objetoPrincipal, 'idPoliza', null);
                    this.$set(this.listGeneral, 'listaSeguros', []);
                    var error = 'E';
                    var p = this.onListar('administrador/producto/listar', objeto)
                        .then((respuesta) => {
                            if (_.size(respuesta.data.data) == 0) {
                                error = 'I';
                                throw respuesta.data.mensaje;
                            }
                            this.$set(this.listGeneral, 'listaSeguros', respuesta.data.data);
                            return this.onListarProductos('L');
                        })
                        .then((respuesta) => {
                            if (_.size(respuesta.data.data) == 0) {
                                error = 'I';
                                throw respuesta.data.mensaje;
                            }
                            return respuesta;
                        });

                    if (event instanceof Event)
                        p.catch((e) => {
                            mensajesAlerta(e, error);
                        });

                    return p;

                }
            },
            onListarPoliza(event) {
                if (!_.isUndefined(event)) {
                    var objeto = {
                        'opcion': 'L_POLIZA',
                        'idAseguradora': _.get(this.objetoPrincipal, 'idAseguradora', null),
                        'idSeguro': _.get(this.objetoPrincipal, 'idSeguro', null),
                        'idEstado': this.parametros.idEstadoDefault
                    };

                    this.$set(this.objetoPrincipal, 'idPoliza', null);
                    this.$set(this.listGeneral, 'listaPolizas', []);
                    var error = 'E';
                    var p = this.onListar('administrador/producto/listar', objeto)
                        .then((respuesta) => {
                            if (_.size(respuesta.data.data) == 0) {
                                error = 'I';
                                throw respuesta.data.mensaje;
                            }
                            this.$set(this.listGeneral, 'listaPolizas', respuesta.data.data);
                            return this.onListarProductos('L');
                        })
                        .then((respuesta) => {
                            if (_.size(respuesta.data.data) == 0) {
                                error = 'I';
                                throw respuesta.data.mensaje;
                            }
                            return respuesta;
                        });

                    if (event instanceof Event)
                        p.catch((e) => {
                            mensajesAlerta(e || e.message, error);
                        });

                    return p;
                }
            },
            onListarEstados(event) {
                if (!_.isUndefined(event)) {
                    this.$set(this.listGeneral, 'listaEstados', []);
                    this.$set(this.listGeneral, 'listaTodosEstados', []);

                    var error = 'E';
                    var p = this.onListar('administrador/catalogo-estado/listar', {
                            'opcion': 'ESTADO'
                        })
                        .then((respuesta) => {
                            if (_.size(respuesta.data.data) == 0) {
                                error = 'I';
                                throw respuesta.data.mensaje;
                            }
                            this.$set(this.listGeneral, 'listaTodosEstados', respuesta.data.data);
                            this.$set(this.listGeneral, 'listaEstados', _.filter(respuesta.data.data, (o) => {
                                return _.toUpper(o.visualiza) == _.toUpper('true')
                            }));
                            return respuesta;
                        });

                    if (event instanceof Event)
                        p.catch((e) => {
                            mensajesAlerta(e || e.message, error);
                        });

                    return p;
                }
            },
            onListarProductos(event) {
                if (!_.isUndefined(event)) {
                    var objeto = {
                        'opcion': 'L_PRODUCTOS',
                        'idAseguradora': _.get(this.objetoPrincipal, 'idAseguradora', null),
                        'idSeguro': _.get(this.objetoPrincipal, 'idSeguro', null),
                        'idPoliza': _.get(this.objetoPrincipal, 'idPoliza', null)
                    };

                    this.$set(this.listGeneral, 'listaProductos', []);
                    var error = 'E';
                    var p = this.onListar('administrador/producto/listar', objeto)
                        .then((respuesta) => {
                            if (_.size(respuesta.data.data) == 0) {
                                error = 'I';
                                throw respuesta.data.mensaje;
                            }
                            this.$set(this.listGeneral, 'listaProductos', _.map(respuesta.data.data,(v) =>{ v.index = _.uniqueId(); return v; }));

                            return respuesta;
                        });

                    if (event instanceof Event)
                        p.catch((e) => {
                            mensajesAlerta(e, error);
                        });

                    return p;
                }
            },
            onNuevo() {
                this.objModal = {
                    abrirModal: true,
                    titulo: 'Nuevo Producto'
                };
            },
            onEditar(objeto) {
                this.titulo = 'Editar Producto';
                this.objModal = _.merge(this.objModal, objeto);
                this.objModal.abrirModal = true;
            },
            insertarActualizar() {
                var keyExpansionPanel = ["activarCancelacionDiasTransferecia", "activarCancelacionDiasCheque", "activarExclusionDiasTransferencia", "activarExclusionDiasCheque" ];

                _.forEach(keyExpansionPanel, (v, k) => {
                    var key = _.camelCase(v.replace("activar", ""));
                    this.listGeneral.listaCondiciones[key] = _.get(this.listGeneral.listaCondiciones, v, false) ? this.listGeneral.listaCondiciones[key] : null;
                });

                var keys = ['listaDatosGenerales', 'listaAccesorios', 'listaBeneficios', 'listaCorreos', 'listaCondiciones', 'listaDocumentos', 'listaVehiProducto' ];
                
                var objeto = {
                    opcion: _.size(this.listGeneral.listaDatosGenerales.idProducto) == 0 ? 'I' : 'U'
                };

                _.forEach(keys, (v) => {
                    _.set(objeto, v, _.get(this.listGeneral, v, []));
                });

                return axios.post(`${BASE_URI}administrador/producto/insertOrUpdate`, objeto)
                    .then((respuesta) => {
                        if (respuesta.status != 200 || respuesta.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                        if (respuesta.data.existeError) throw respuesta.data.mensaje;
                        if (_.size(respuesta.data.data) > 0) {
                            mensajeAlertaTiempo(respuesta.data.mensaje, 'S');
                            setTimeout(() => {
                                location.reload();
                            }, 1600);
                        }

                        return respuesta;
                    }).catch((e) => {
                        mensajesAlerta(e, 'E');
                        return e;
                    });
            },
            cerrarModal() {
                var listas = ['cabeceraBeneficios', 'listaBeneficios', 'listaCorreos', 'catalogoBeneficios',
                    'listaDocumentos'
                ];

                _.forEach(listas, (v) => {
                    _.set(this.listGeneral, v, []);
                });
                this.objModal.abrirModal = false;
            }
        },
        provide() {
            return {
                onListar: this.onListar,
                insertarActualizar: this.insertarActualizar,
                cerrarModal: this.cerrarModal
            }
        }
    }
</script>